import { useEffect, useState } from 'react';
import { getGrupos as getGroups } from 'controllers/qualidade';
import { GetToken } from 'components/util/Helpers/Auth';
interface IGroup {
  cd_grupo: number;
  nm_grupo: string;
  cd_div: number;
}

interface IError {
  error: boolean;
  message: string;
}

const shapeGroups = (groups: IGroup[]) => {
  groups.unshift({
    cd_grupo: 0,
    nm_grupo: 'Selecione um grupo',
    cd_div: 0
  });
  const newGroups = removeBuggedGroup(groups);
  return newGroups.sort(sortGroupsByCd);
};

const sortGroupsByCd = (a: IGroup, b: IGroup) => {
  if (a.cd_grupo < b.cd_grupo) {
    return -1;
  }
  if (a.cd_grupo > b.cd_grupo) {
    return 1;
  }
  return 0;
};

//Remove grupo bugado da lista { "cd_grupo": 15, "nm_grupo": "15 - .", "cd_div": 1 }
const removeBuggedGroup = (groups: IGroup[]) => {
  return groups.filter((group) => group.nm_grupo !== '15 - .');
};

const fetchGroups = async (inAcessMoveis: string): Promise<IGroup[]> => {
  return getGroups({
    token: GetToken(),
    params: { inAcessMoveis }
  }).then((res) => JSON.parse(res.body));
};

export const useGroupsFilters = () => {
  const [groups, setGroups] = useState([] as IGroup[]);
  const [groupsError, setGroupsError] = useState<IError>({ error: false, message: '' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const acessorios: IGroup[] = await fetchGroups('A');
        const moveis: IGroup[] = await fetchGroups('P');

        let groups = [...acessorios, ...moveis];

        groups = shapeGroups(groups);
        setGroups(groups);
      } catch (error) {
        setGroupsError({ error: true, message: 'Usuário não tem permissão para acessar funcionalidades' });
      }
    };

    fetchData();
  }, []);

  return { groups, groupsError };
};
